/**
 * How an agent-assisted lead is marked for attribution.
 *
 * The marker goes inside `attribution_trail` rather than in a field of its own
 * because the portal's leads webhook cherry-picks the keys it knows and drops
 * the rest without complaint - the trail is the one key it stores verbatim.
 */
import type { AdAttribution } from '@/utils/adAttribution';

export type AgentOrigin = 'webmcp' | 'mcp';

export function serialiseTrail(
  attribution: AdAttribution | null,
  agentOrigin: AgentOrigin | null,
): string {
  if (!attribution) return '';

  const trail = agentOrigin
    ? { ...attribution.trail, channel: 'agent', agent: { origin: agentOrigin } }
    : attribution.trail;

  return JSON.stringify(trail);
}
